import { useState, useEffect, Fragment } from 'react';
// import { loadStripe } from "@stripe/stripe-js";

// import Loader from '~components/Loader/Loader';
import Loader from '../Loader/Loader';
import { useHookStore } from '../../hook-store/store';
import { 
  getCustomerCardPaymentMethods,
  cardExpire,
 } from '../../utils/stripe/payment-method-utils';

// import { 
//   BACKEND_URL,  
// } from '~config/endpoints';
import {
  IMAGEPHOTO_BACKENDURL
} from '../../lib/api';


function GetPaymentMethods(props) {

  const [store, dispatch] = useHookStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    usageBasedPrice,
    usageBasedSubscription,
    customerMethods,
    usageBasedValidMethod,
  } = store.stripeData;
  const { gLoading } = store.uiStore;

  const [isLoading, setIsLoading] = useState(false);



  useEffect(() => {
    if (customerMethods.length === 0) {
      getPaymentMethodsHandler();
    }
  },[usageBasedSubscription]);

  useEffect(() => {
    if (customerMethods.length > 0 && usageBasedSubscription) {
      const methodList = [];

      for (const method of customerMethods) {
        const cardExpired = cardExpire(method.card.exp_month, method.card.exp_year);
        
        if (!cardExpired) {
          methodList.push(method);
        }
      }
  
      console.log(methodList);
      // if (methodList.length === 1) {
      //   dispatch('SET_VALID_DEFAULTMETHOD', methodList[0]);
      // }
  
      if (methodList.length > 0) {
        const subscriptionMethod = methodList.find(method => {
          return method.id === usageBasedSubscription.default_payment_method;
        });

        if (subscriptionMethod) {
          dispatch('SET_USAGEBASEDVALIDMETHOD', subscriptionMethod);
        } else {
          dispatch('SET_USAGEBASEDVALIDMETHOD', null);
        }
      }
      else {
        dispatch('SET_USAGEBASEDVALIDMETHOD', null);
      }
    }
  },[customerMethods, usageBasedSubscription]);


  const getPaymentMethodsHandler = async () => {
    try {
      setIsLoading(true);
      // setError('');

      const resData = await getCustomerCardPaymentMethods(
        IMAGEPHOTO_BACKENDURL, 
        localStorage.getItem('token'),
        localStorage.getItem('customerId'),
      );

      // console.log();

      if (resData.data) {
        const usageBasedList = resData.data.filter(method => {
          return method.metadata && method.metadata.imagePhotoUsageBased;
        });

        // console.log(methodList);
        // setCustomerMethods(result.customerMethods);
        // setCustomerMethods(methodList);
        dispatch('SET_CUSTOMERMETHODS', usageBasedList);

        // setDefaultMethod(methodList);

      }
      setIsLoading(false);

    } catch(err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  
  let getPaymentMethodsBody;

  // if (usageBasedValidMethod) {
  //   getPaymentMethodsBody = (
  //     <div>usage-based-sub-valid-method-there</div>
  //   );
  // }

  // if (!usageBasedValidMethod) {
  //   getPaymentMethodsBody = (
  //     <div>no-usage-based-sub-valid-method</div>
  //   );
  // }

  if (isLoading) {
    getPaymentMethodsBody = (
      <div><Loader /></div>
    );
  }




  return (
    <Fragment>
      <div>
        {getPaymentMethodsBody}
      </div>
    </Fragment>
  );
}

export default GetPaymentMethods;
